import { SlidesAiEditLatencyTracker } from './slides-ai-edit-latency-tracker';

export const slidesAiEditLatency: SlidesAiEditLatencyTracker = new SlidesAiEditLatencyTracker();
